import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { FaRoute } from 'react-icons/fa';

const EDIT_ACTION_BUTTON_STYLE = {
  minWidth: 110,
};

const CANCEL_BUTTON_STYLE = {
  ...EDIT_ACTION_BUTTON_STYLE,
  backgroundColor: '#dc3545',
  borderColor: '#dc3545',
  color: '#ffffff',
  transition: 'none',
  boxShadow: 'none',
};

const RouteSummaryBar = ({
  tourEstimateLabel,
  tourMiles,
  canSaveRoute,
  saving,
  onCancel,
  onSaveNew,
  onUpdate,
  editingTourId,
}) => {
  return (
    <div className="route-summary-bar d-flex align-items-center gap-3">
      <div className="flex-grow-1 text-white">
        <div className="fw-semibold small text-nowrap">Tour Estimate:</div>
        <div className="fw-semibold small text-nowrap">{tourEstimateLabel}</div>
        <div className="small d-flex align-items-center gap-2 mt-1">
          <FaRoute />
          <span>{tourMiles != null ? `${tourMiles.toFixed(1)} mi` : '--'}</span>
        </div>
      </div>
      <div className="d-flex gap-2 ms-auto">
        <Button
          variant={!canSaveRoute || saving ? 'secondary' : 'primary'}
          disabled={!canSaveRoute || saving}
          onClick={onSaveNew}
          title={
            canSaveRoute ? 'Save as a new tour' : 'Build a tour with a valid start and end first'
          }
        >
          {saving ? <Spinner animation="border" size="sm" className="me-2" /> : null}
          Save as New
        </Button>
        <Button
          variant={!canSaveRoute || !editingTourId || saving ? 'secondary' : 'primary'}
          disabled={!canSaveRoute || !editingTourId || saving}
          onClick={onUpdate}
          title={editingTourId ? 'Update this tour' : 'Select a tour to edit before updating'}
          style={EDIT_ACTION_BUTTON_STYLE}
        >
          {saving ? <Spinner animation="border" size="sm" className="me-2" /> : null}
          Update
        </Button>
        <Button
          variant="danger"
          disabled={saving}
          onClick={onCancel}
          title="Cancel editing"
          style={CANCEL_BUTTON_STYLE}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default RouteSummaryBar;
